
import React from "react";
import { NavigationMenuItem, NavigationMenuTrigger, NavigationMenuContent } from "@/components/ui/navigation-menu";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { TabContentWithImage } from "./TabContent";

interface ConsultingMenuProps {
  activeTab: string;
  onTabChange: (value: string) => void;
  allImagesLoaded: boolean;
}

export const ConsultingMenu: React.FC<ConsultingMenuProps> = ({
  activeTab,
  onTabChange,
  allImagesLoaded
}) => {
  return (
    <NavigationMenuItem>
      <NavigationMenuTrigger className="bg-transparent hover:bg-gray-200 text-primary text-sm font-medium">Consulting</NavigationMenuTrigger>
      <NavigationMenuContent className="w-[95vw] min-w-[95vw] max-w-[1000px] h-[500px] bg-white rounded-md shadow-lg p-4 border border-gray-200">
        <Tabs value={activeTab} onValueChange={onTabChange} orientation="vertical" className="flex">
          <TabsList className="flex flex-col w-1/4 h-[450px] bg-gray-50 rounded-l-md space-y-1 p-2 border-r border-primary portrait:w-1/4 portrait:min-w-[120px]">
            <TabsTrigger value="hradvisory" className="w-full text-left pl-3 pr-3 text-primary-dark data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:rounded-none min-w-[100px] portrait:min-w-[100px] portrait:text-xs portrait:px-2 portrait:w-full portrait:text-left portrait:justify-start">
              HR Advisory
            </TabsTrigger>
            <TabsTrigger value="salesadvisory" className="w-full text-left pl-3 pr-3 text-primary-dark data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:rounded-none min-w-[100px] portrait:min-w-[100px] portrait:text-xs portrait:px-2 portrait:w-full portrait:text-left portrait:justify-start">
              Sales Advisory
            </TabsTrigger>
            <TabsTrigger value="marketingadvisory" className="w-full text-left pl-3 pr-3 text-primary-dark data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:rounded-none min-w-[100px] portrait:min-w-[100px] portrait:text-xs portrait:px-2 portrait:w-full portrait:text-left portrait:justify-start">
              Marketing Advisory
            </TabsTrigger>
            <TabsTrigger value="financeadvisory" className="w-full text-left pl-3 pr-3 text-primary-dark data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:rounded-none min-w-[100px] portrait:min-w-[100px] portrait:text-xs portrait:px-2 portrait:w-full portrait:text-left portrait:justify-start">
              Finance Advisory
            </TabsTrigger>
            <TabsTrigger value="projectsadvisory" className="w-full text-left pl-3 pr-3 text-primary-dark data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:rounded-none min-w-[100px] portrait:min-w-[100px] portrait:text-xs portrait:px-2 portrait:w-full portrait:text-left portrait:justify-start">
              Projects Advisory
            </TabsTrigger>
            <TabsTrigger value="performanceadvisory" className="w-full text-left pl-3 pr-3 text-primary-dark data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:rounded-none min-w-[100px] portrait:min-w-[100px] portrait:text-xs portrait:px-2 portrait:w-full portrait:text-left portrait:justify-start">
              Performance Advisory
            </TabsTrigger>
            <TabsTrigger value="legaladvisory" className="w-full text-left pl-3 pr-3 text-primary-dark data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:rounded-none min-w-[100px] portrait:min-w-[100px] portrait:text-xs portrait:px-2 portrait:w-full portrait:text-left portrait:justify-start">
              Legal Advisory
            </TabsTrigger>
            <TabsTrigger value="professionalservices" className="w-full text-left pl-3 pr-3 text-primary-dark data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:rounded-none min-w-[100px] portrait:min-w-[100px] portrait:text-xs portrait:px-2 portrait:w-full portrait:text-left portrait:justify-start">
              Professional Services
            </TabsTrigger>
            <TabsTrigger value="customdevelopment" className="w-full text-left pl-3 pr-3 text-primary-dark data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:rounded-none min-w-[100px] portrait:min-w-[100px] portrait:text-xs portrait:px-2 portrait:w-full portrait:text-left portrait:justify-start">
              Custom Development
            </TabsTrigger>
          </TabsList>
          <TabsContent value="hradvisory" className="w-2/3 p-4 portrait:w-3/4 portrait:p-2 overflow-auto max-h-[450px]">
            <TabContentWithImage
              imageSrc="https://images.unsplash.com/photo-1507537297725-24a1c029d3ca?w=400&h=300&fit=crop&auto=format&q=80&sat=-100"
              imageAlt="HR Advisory"
              title="HR Advisory"
              description="Expert guidance on talent acquisition, organizational development, and AI-powered HR transformation strategies."
              allImagesLoaded={allImagesLoaded}
            />
          </TabsContent>
          <TabsContent value="salesadvisory" className="w-2/3 p-4 portrait:w-3/4 portrait:p-2 overflow-auto max-h-[450px]">
            <TabContentWithImage
              imageSrc="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=400&h=300&fit=crop&auto=format&q=80&sat=-100"
              imageAlt="Sales Advisory"
              title="Sales Advisory"
              description="Strategic consulting on enhancing sales processes, customer acquisition, and revenue growth through AI solutions."
              allImagesLoaded={allImagesLoaded}
            />
          </TabsContent>
          <TabsContent value="marketingadvisory" className="w-2/3 p-4 portrait:w-3/4 portrait:p-2 overflow-auto max-h-[450px]">
            <TabContentWithImage
              imageSrc="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=400&h=300&fit=crop&auto=format&q=80&sat=-100"
              imageAlt="Marketing Advisory"
              title="Marketing Advisory"
              description="Transformative marketing strategies leveraging AI for customer engagement, brand building, and campaign optimization."
              allImagesLoaded={allImagesLoaded}
            />
          </TabsContent>
          <TabsContent value="financeadvisory" className="w-2/3 p-4 portrait:w-3/4 portrait:p-2 overflow-auto max-h-[450px]">
            <TabContentWithImage
              imageSrc="https://images.unsplash.com/photo-1580519542036-c47de6196ba5?w=400&h=300&fit=crop&auto=format&q=80&sat=-100"
              imageAlt="Finance Advisory"
              title="Finance Advisory"
              description="Expert guidance on financial analytics, forecasting, and AI-powered strategies for optimizing financial operations."
              allImagesLoaded={allImagesLoaded}
            />
          </TabsContent>
          <TabsContent value="projectsadvisory" className="w-2/3 p-4 portrait:w-3/4 portrait:p-2 overflow-auto max-h-[450px]">
            <TabContentWithImage
              imageSrc="https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?w=400&h=300&fit=crop&auto=format&q=80&sat=-100"
              imageAlt="Projects Advisory"
              title="Projects Advisory"
              description="Comprehensive project management consulting with AI-driven planning, resource optimization, and execution strategies for successful project delivery."
              allImagesLoaded={allImagesLoaded}
            />
          </TabsContent>
          <TabsContent value="performanceadvisory" className="w-2/3 p-4 portrait:w-3/4 portrait:p-2 overflow-auto max-h-[450px]">
            <TabContentWithImage
              imageSrc="https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=400&h=300&fit=crop&auto=format&q=80&sat=-100"
              imageAlt="Performance Advisory"
              title="Performance Advisory"
              description="Strategic performance management consulting to enhance employee productivity, goal alignment, and organizational excellence through AI-powered insights."
              allImagesLoaded={allImagesLoaded}
            />
          </TabsContent>
          <TabsContent value="legaladvisory" className="w-2/3 p-4 portrait:w-3/4 portrait:p-2 overflow-auto max-h-[450px]">
            <TabContentWithImage
              imageSrc="https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=400&h=300&fit=crop&auto=format&q=80&sat=-100"
              imageAlt="Legal Advisory"
              title="Legal Advisory"
              description="Comprehensive legal consulting on regulatory compliance, risk management, and AI-enabled legal operations."
              allImagesLoaded={allImagesLoaded}
            />
          </TabsContent>
          <TabsContent value="professionalservices" className="w-2/3 p-4 portrait:w-3/4 portrait:p-2 overflow-auto max-h-[450px]">
            <TabContentWithImage
              imageSrc="https://images.unsplash.com/photo-1521791136064-7986c2920216?w=400&h=300&fit=crop&auto=format&q=80&sat=-100"
              imageAlt="Professional Services"
              title="Professional Services"
              description="Specialized implementation and integration services to maximize your investment in AI solutions across the enterprise."
              allImagesLoaded={allImagesLoaded}
            />
          </TabsContent>
          <TabsContent value="customdevelopment" className="w-2/3 p-4 portrait:w-3/4 portrait:p-2 overflow-auto max-h-[450px]">
            <TabContentWithImage
              imageSrc="https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=400&h=300&fit=crop&auto=format&q=80&sat=-100"
              imageAlt="Custom Development"
              title="Custom Development"
              description="Full-stack custom development services incorporating AI capabilities are also available from Ingant. Email us at support@ingant.com to find out more."
              allImagesLoaded={allImagesLoaded}
            />
          </TabsContent>
        </Tabs>
      </NavigationMenuContent>
    </NavigationMenuItem>
  );
};
